import React from "react"
import Review from "./Review"

class Reviews extends React.PureComponent{
    render(){
        return(
            <div className="reviews section">
                <h2 className="sectionTitle">All Reviews</h2> 
                {this.props.reviews == null
                ? <p className="description">
                    There's no reviews for this game yet.
                </p>
                :<>
                <div className="description">
                    {this.props.reviews.map(review => 
                    <Review key={review.id} upvote={review.upvote} comment={review.content} 
                            date={review.updatedAt} user={review.user.displayName} />)}
                </div>
                </>}
            </div>
        )
    }
}

export default Reviews